<template>
  <section class="cover" data-type="cover" id="cover">
    <div
      class="cover__content"
      :class="productBrand.toLowerCase()">
      <div class="cover__image__container">
        <div class="cover__header">
          <img class="cover__logo" :src="brandLogo"/>
        </div>
        <img
          class="cover__image"
          v-if="projectInfo.cover_photo.value.url"
          :alt="projectInfo.cover_photo.value.name"
          :src="projectInfo.cover_photo.value.url">
        <div class="cover__image-placeholder" v-else>
        </div>
      </div>
      <div class="cover__info">
        <div>
          <div class="title is-1 cover__text">
            {{ projectInfo.name.value }}
          </div>
          <div class="subtitle is-4 cover__text">
            {{ projectInfo.address.value }}
          </div>
        </div>
      </div>
      <div class="cover__footer">
        <div class="cover__text">
          {{ projectInfo.sales_person.value.From }}
        </div>
        <div class="cover__text">
          {{ formatDate(projectInfo.date.value) }}
        </div>
        <div class="cover__text">
          {{ productBrand }} Estimate
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    projectInfo: {
      type: Object,
      required: true
    },
    productBrand: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formatDate: (date) => {
        return date ? format(date, "MM/dd/yyyy") : null;
      }
    }
  },
  computed: {
    brandLogo() {
      return this.productBrand == 'Mitrex' ? 
        require('../../assets/mitrex_logo_sm.png') :
        require('../../assets/cladify_logo_sm.png');
    }
  }
}
</script>

<style scoped>
@import '../../styles/cover-page.css';
</style>